import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './style.css';

// Runtime config'i yükle
fetch('/runtime-config.json')
  .then(response => response.json())
  .then(config => {
    // Global config'e ata
    window.RUNTIME_CONFIG = config;
    
    // React uygulamasını başlat
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  })
  .catch(error => {
    console.error('Runtime config yüklenemedi:', error);
    
    // Config yüklenemese bile uygulamayı başlat (fallback değerlerle)
    window.RUNTIME_CONFIG = {};
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(<App />);
  });

